import { ItemCounterComponent } from './item-counter/item-counter.component';
import { ItemsPerPageComponent } from './items-per-page/items-per-page.component';

export const Components = [
	ItemCounterComponent,
	ItemsPerPageComponent,
];
